// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.accounting.practicepay.PracticePayDeleteStoredPaymentMethodRequest */
/* istanbul ignore next */
@GandalfModel
export class PracticePayDeleteStoredPaymentMethodRequest extends GandalfModelBase {

	@GandalfLabel('Person')
	@GandalfProperty({ designType: Number })
	personId!: number;

	@GandalfLabel('Practice Location')
	@GandalfProperty({ designType: Number })
	practiceLocationId!: number;

	@GandalfLabel('Stored Payment Method Identifier')
	@GandalfValidator({ notNull: { message: 'Stored Payment Method Identifier is required' } })
	@GandalfProperty({ designType: String, isRequired: true })
	storedPaymentMethodIdentifier!: string;

}
